// extracted by mini-css-extract-plugin
export default {"custom-sidebar":"SignOutButton_custom-sidebar__SCP9K","tertiary-badge":"SignOutButton_tertiary-badge__gDR9j","userInitials":"SignOutButton_userInitials__jjAcS"};